import { getEnv } from "../utils";
import apiService from "./ApiService";

export const getPricing = (priceId: string, lang = "en", country = "en") => {
  return apiService.get<{ uuid: string; priceId: string }>({
    path: "pricing",
    headers: {
      "X-Blk-Brand": null as any, // remove to avoid CORS issue
    },
    params: {
      env: getEnv().name,
      lang,
      country,
      offer: "true",
      priceid: priceId,
    },
    requiresAuthPolicy: null as any, // no auth
    cms: true,
  });
};
